(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/games.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/games.js');

'use strict';

var _svs$numbergames$frac;
const {
  useMemo,
  useState,
  useCallback,
  useEffect
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const Icon = svs.ui.ReactIcon;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  ReservedGamesMessage
} = svs.numbergames.fractiongames.components;
const {
  GameCard,
  GameCardError
} = svs.numbergames.fractiongames.components.gamecard;
const payGame = svs.numbergames.fractiongames.redux.thunks.payGame;
const hasReservedGames = (_svs$numbergames$frac = svs.numbergames.fractiongames.data.reservedgames) === null || _svs$numbergames$frac === void 0 ? void 0 : _svs$numbergames$frac.hasReservedGames;
const {
  createSortedContainersSelector
} = svs.numbergames.fractiongames.redux.slices.containers.selectors;
const {
  CampaignContextProvider,
  ContainerContextProvider
} = svs.numbergames.fractiongames.contexts;
const Games = _ref => {
  let {
    productFilter
  } = _ref;
  const selectContainerIds = useMemo(() => createSortedContainersSelector(productFilter), [productFilter]);
  const containerIds = useSelector(selectContainerIds);
  const [hasReserved, setHasReserved] = useState(hasReservedGames);
  const dispatch = useDispatch();
  const handlePayEvent = useCallback(containerId => {
    dispatch(payGame(containerId, () => setHasReserved(true)));
  }, [dispatch]);
  useEffect(() => {
    if (svs.utils.paramHandler.get({
      key: 'containerId'
    }).value && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'containerId'
      });
    }
    const containerIdParam = svs.utils.paramHandler.get({
      key: 'containerId'
    });
    if (containerIdParam) {
      const containerId = containerIds.find(containerId => containerId === parseInt(containerIdParam.value, 10));
      if (containerId) {
        handlePayEvent(containerId);
      }
      svs.utils.paramHandler.remove({
        key: 'containerId'
      });
    }
  }, [containerIds, handlePayEvent]);
  if (!containerIds.length) {
    return React.createElement("p", {
      className: "ng-fg-message"
    }, React.createElement(Icon, {
      size: "500",
      icon: "exclamation-sign"
    }), " Andelsspel kan inte visas.");
  }
  return React.createElement(React.Fragment, null, hasReserved && React.createElement(ReservedGamesMessage, null), React.createElement("div", {
    className: "ng-fg-games-container"
  }, React.createElement(CampaignContextProvider, null, containerIds.map(containerId => React.createElement(ContainerContextProvider, {
    key: containerId,
    containerId: containerId
  }, React.createElement(ErrorBoundary, {
    fallback: () => React.createElement(GameCardError, null)
  }, React.createElement(GameCard, {
    onPayEvent: handlePayEvent
  })))))));
};
svs.numbergames.fractiongames.components.Games = Games;

 })(window);